/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-restricted-globals */
import React from 'react';
import { useSelector } from 'react-redux';
import MemberNavigator from './MemberNavigator';


const MemberNavigatorContainer = ({ queryClient }) => {
  const isAppDrawerOpen = useSelector((state) => state.commonStates.isAppDrawerOpen);

  return (
    <MemberNavigator isAppDrawerOpen={isAppDrawerOpen} queryClient={queryClient} />
  );
};

export default MemberNavigatorContainer;
